import React, { useRef } from "react";
import "../../../Assets/Css/Appreciation.scss";
import Table from "../../../Components/Table";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import qs from "query-string";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import CustomCalendar from '../../../Components/CustomCalendar';
import AppreciationIcon from '../../../Assets/Images/Appreciation/Appreciation'
import TrophyIcon from '../../../Assets/Images/Appreciation/Trophy'
import { getAppreciations } from "../../../Services/Appreciation/action";
import moment from "moment";
import { deleteRecord } from "../../../Services/Delete/action";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../../Lib/RoleWiseFeatureWrapper";
import ModulesList from "../../../Assets/ModulesLiist";
import FeaturesList from "../../../Assets/FeaturesList";


const Appreciation = (props) => {
    const [checked, setChecked] = useState(false);
    const [selectedId, setSelectedId] = useState([]);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [activeButton, setActiveButton] = useState("");
    const { employeeId } = useParams();
    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Appreciation,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Appreciation,
        Featur_Name: FeaturesList.Delete,
    });
    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Appreciation,
        Featur_Name: FeaturesList.Update,
    });
    const fileInputRef = useRef(null);
    const modalRef = useRef(null);

    const navigate = useNavigate();
    const location = useLocation();

    const header = [
        { field: "Award" },
        { field: "Date" },
        { field: "Action" },
    ];

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        const path = location.pathname;
        setActiveButton(path.split('/').pop())
    }, []);

    useEffect(() => {
        setIsLoading(true)
        fetchData();
        setIsLoading(false)
    }, [location.search]);

    const handleClickBtn = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
        console.log(buttonId, "name button")
    };

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props.getAppreciations();
        } catch (error) {
            console.error("Error fetching appreciations:", error);
        }
    };

    useEffect(() => {
        props?.appreciation
            ? setInData(
                props?.appreciation?.filter((item) => item?.given_to_employeeId == employeeId)?.map((item) => {
                    return {
                        "Award": {
                            icon: item?.award?.icon,
                            value: item?.award?.title,
                            value2: item?.award?.icon_background_color,
                            type: 'award',
                        },
                        "Date": {
                            value: item?.date?.split(" ")[0],
                            type: "date",
                        },
                        Action: {
                            value2: `/employees/view/${employeeId}/appreciation/view`,
                            value: `/employees/view/${employeeId}/appreciation/edit`,
                            value3: item?.id,
                            type: "action",
                        },
                        allData: {
                            ...item
                        }
                    };
                })
            )
            : setInData([]);
    }, [props?.appreciation]);

    const handleClose = () => {
        setShowModal(false);
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
                setFileName('');
                setSelectedFile(null);
                fileInputRef.current.value = null;
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClose]);

    const handleChange = (e) => {
        if (e[1] == "headerAll" && e[0] === true) {
            setTotalSelectedIds([...e[2]]);
        } else if (e[0] === true && e[1] !== "headerAll") {
            setTotalSelectedIds([...totalSelectedIds, e[1]]);
        } else if (e[1] == "headerAll" && e[0] === false) {
            setTotalSelectedIds([]);
        } else {
            let filterdId = totalSelectedIds.filter((item) => {
                return item != e[1];
            });
            setTotalSelectedIds(filterdId);
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const handleAddClick = () => {
        navigate(`/employees/view/${employeeId}/appreciation/add`);
    }

    const initialState = {
        date: ""
    }

    const [clientData, setClientData] = useState(initialState);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const applyFilters = ({ startDate, endDate, search }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((leave) => {
            let matchesSearch = true;
            let matchesDate = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(leave?.Date?.value).startOf('day');
                const itemDueDate = leave?.Date?.value
                    ? moment(leave?.Date?.value).startOf('day')
                    : itemStartDate;

                const filterStart = moment(filteredStartDate || startDate).startOf('day');
                const filterEnd = moment(filteredEndDate || endDate).endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
            }
            if (search) {
                matchesSearch = leave?.Award?.value?.toLowerCase()?.includes(search?.toLowerCase());
            }
            return matchesSearch && matchesDate;
        });
        setFilteredData(filtered);
    };

    const handleClear = () => {
        setClientData({
            awardname: ""
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))
        setSearchTerm(value);
        applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, search: value });
    }

    return (
        <div className="appreciation-main">
            <div className="page-title">
                <h4> Appreciation </h4>
                <div>
                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.Appreciation}
                        Featur_Name={FeaturesList.Create}>

                        <button className="custom-appreciation-btn" disabled={props.loading} onClick={handleAddClick}>
                            {props.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Add Appreciation"}
                        </button>
                    </RoleWiseFeatureWrapper>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4">
                    <div className="input-group">
                        <CustomCalendar
                            inData={inData}
                            searchTerm={searchTerm}
                            setFilteredData={setFilteredData}
                            applyFilters={(params) => { applyFilters(params) }}
                            startDate={filteredStartDate}
                            endDate={filteredEndDate}
                            setStartDate={setFilteredStartDate}
                            setEndDate={setFilteredEndDate} />
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="input-group">
                        <input type="text" className="input-css" name='awardname' placeholder='Search Award Name' onChange={searchFiled} />
                    </div>
                </div>


                <div className="col-lg-4">
                    {(searchTerm || filteredData?.length > 0 || dateStatus) && (
                        <button
                            className="export-btn"
                            disabled={props.loading}
                            onClick={handleClear}
                        >
                            {props.loading ? (
                                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                            ) : (
                                'Clear'
                            )}
                        </button>
                    )}
                </div>
            </div>

            <div className="gap-4 addappreciation-export-btn">
                <div>


                    {/* <button
                        className="export-btn"
                        id="exportBtn"
                        disabled={!checked || exportLoading}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClick(totalSelectedIds, "export");
                        }}
                    >
                        {exportLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Export"
                        )}
                    </button> */}
                </div>

                <div className="navigation_btn" style={{ marginBottom: "15px", marginTop: "15px" }}>
                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.Appreciation}
                        Featur_Name={FeaturesList.View}>

                        <button
                            className={`btn1 ${activeButton === "appreciation" ? "active" : ""}`}
                            onClick={() => handleClickBtn("appreciation", `/employees/view/${employeeId}/appreciation`)}
                        >
                            <AppreciationIcon color={activeButton === "appreciation" ? "white" : "black"} bgColor={activeButton === "appreciation" ? "black" : "transparent"} />
                        </button>
                    </RoleWiseFeatureWrapper>

                    <RoleWiseFeatureWrapper
                        modules={props?.modules}
                        features={props?.features}
                        user={props?.user}
                        ModuleName={ModulesList.Award}
                        Featur_Name={FeaturesList.View}>

                        <button
                            className={`btn1 ${activeButton === "award" ? "active" : ""}`}
                            onClick={() => handleClickBtn("award", `/employees/view/${employeeId}/award`)}
                        >
                            <TrophyIcon color={activeButton === "award" ? "white" : "black"} bgColor={activeButton === "award" ? "black" : "transparent"} />
                        </button>
                    </RoleWiseFeatureWrapper>
                </div>
            </div>

            <div className="invoice-table-part">
                <Table
                    header={header}
                    data={(searchTerm || dateStatus) ? filteredData : inData}
                    footer={footer}
                    count={count}
                    checked={checked}
                    records={count}
                    totalSelectedIds={totalSelectedIds}
                    defaultParams={params}
                    selectedId={selectedId}
                    handleChange={handleChange}
                    loading={props.loading}
                    showIsView={canView}
                    showIsDelete={canDelete}
                    showIsEdit={canEdit}
                    deleteRecord={props?.deleteRecord}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {

        loading: state.invoicesReducer.loading,
        appreciation: state.appreciationReducer.appreciation,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getAppreciations: () => {
            dispatch(getAppreciations())
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue));
            await dispatch(getAppreciations());
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Appreciation);
